define('OrderWizard.Module.ShowShipments.Extension', [
  'OrderWizard.Module.ShowShipments',
  'initWestSelectShipping',
  'underscore'
], function(
  OrderWizardModuleShowShipments,
  initWestSelectShipping,
  _
) {
  'use strict';

  return _.extend(OrderWizardModuleShowShipments.prototype, {

    initialize: _.wrap(OrderWizardModuleShowShipments.prototype.initialize, function(fn) {
      try {
        fn.apply(this, _.toArray(arguments).slice(1));
        initWestSelectShipping(this);
      } catch(err) { console.error(420487, err); }
    })

  });

});
